import React, { useEffect, useRef } from 'react'
import { Animated, ColorValue, Easing, StyleSheet, View, ViewProps, ViewStyle } from 'react-native'

import { Color } from '../../style'

interface StyleConfig {
  container?: ViewStyle
  bar?: ViewStyle
}

const largeSizeConfig: StyleConfig = {
  container: {
    height: 20,
    borderRadius: 10,
  },
  bar: {
    borderRadius: 10,
  },
}

const mediumSizeConfig: StyleConfig = {
  container: {
    height: 10,
    borderRadius: 5,
  },
  bar: {
    borderRadius: 5,
  },
}

const smallSizeConfig: StyleConfig = {
  container: {
    height: 6,
    borderRadius: 3,
  },
  bar: {
    borderRadius: 3,
  },
}

const SizeConfig = {
  L: largeSizeConfig,
  M: mediumSizeConfig,
  S: smallSizeConfig,
}

export type Size = keyof typeof SizeConfig
export const Sizes = Object.keys(SizeConfig) as Size[]

const styles = StyleSheet.create({
  container: {},
  bar: {
    height: '100%',
  },
})

export interface Props extends ViewProps {
  size?: Size
  value?: number
  barColor?: ColorValue
  trackColor?: ColorValue
}

let _lastValue: number | undefined
const ProgressBar = (props: Props) => {
  const {
    value = 0,
    style,
    size = 'M',
    barColor = Color.premiumBlack,
    trackColor = Color.sleepingGrey,
    ...otherProps
  } = props
  const width = useRef(new Animated.Value(value)).current

  useEffect(() => {
    if (_lastValue) {
      Animated.timing(width, {
        toValue: _lastValue,
        useNativeDriver: false,
        duration: 0,
        easing: Easing.inOut(Easing.linear),
      }).start()
    }
    Animated.timing(width, {
      toValue: value,
      useNativeDriver: false,
      easing: Easing.inOut(Easing.linear),
    }).start(() => {
      _lastValue = undefined
    })
    _lastValue = value
  }, [value])

  const sizeConfig = SizeConfig[size]

  const containerStyle = {
    backgroundColor: trackColor,
  }

  const barStyle = {
    backgroundColor: barColor,
    width: width.interpolate({
      inputRange: [0, 1],
      outputRange: ['0%', '100%'],
      extrapolate: 'clamp',
    }),
  }
  return (
    <View style={[styles.container, sizeConfig.container, containerStyle, style]} {...otherProps}>
      <Animated.View style={[styles.bar, sizeConfig.bar, barStyle]} />
    </View>
  )
}

export default ProgressBar
